query MfaSessionScans($runId: ConditionID!, $scanNameFilter: ConditionString, $limit: Int = 1000) {
	scans(run_id_eq: $runId, scan_name_eq: $scanNameFilter, limit: $limit) {
		scan_id
		created_at
	}
}
